export const getUpdatePermissionsState = ({
  prev,
  permission_type,
  user_id,
  users,
  role,
}) => {
  if (!prev) return prev;

  const permissions = prev.permissions || [];

  switch (permission_type) {
    case "remove":
      return {
        ...prev,
        permissions: permissions.filter((item) => item.user_id !== user_id),
      };

    case "update":
      return {
        ...prev,
        permissions: permissions.map((item) =>
          item.user_id === user_id
            ? {
                ...item,
                role,
              }
            : item,
        ),
      };

    default: {
      const user = users?.find((item) => item.id === user_id);

      return {
        ...prev,
        permissions: [
          ...permissions,
          {
            ...user,
            user_id,
            role,
          },
        ],
      };
    }
  }
};
